import { render, staticRenderFns } from "./FarmsTable.vue?vue&type=template&id=58a9c9f2&scoped=true&"
import script from "./FarmsTable.vue?vue&type=script&lang=js&"
export * from "./FarmsTable.vue?vue&type=script&lang=js&"
import style0 from "./FarmsTable.vue?vue&type=style&index=0&id=58a9c9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a9c9f2",
  null
  
)

export default component.exports